import { render, staticRenderFns } from "./TripView.vue?vue&type=template&id=5cecf0f2&scoped=true"
import script from "./TripView.vue?vue&type=script&lang=js"
export * from "./TripView.vue?vue&type=script&lang=js"
import style0 from "./TripView.vue?vue&type=style&index=0&id=5cecf0f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cecf0f2",
  null
  
)

export default component.exports